import fetch from "./fetch";
/**
 * 专题相关
 */
const subject = {
  // 专题列表
  specialSubjectRequst(data) {
    return fetch({
      isLoading: true,
      url: "/specialSubject/page",
      method: "GET",
      params: data,
    });
  },

  // 新增专题
  addSpecialSubjectRequst(data) {
    return fetch({
      isLoading: true,
      url: "/specialSubject/save",
      method: "POST",
      data,
    });
  },
  // 修改专题(编辑/删除)
  updateSpecialSubjectRequst(data) {
    return fetch({
      isLoading: true,
      url: "/specialSubject/update",
      method: "POST",
      data,
    });
  },

  // 关联列表
  subjectLinkRequst(data) {
    return fetch({
      isLoading: true,
      url: "/subjectLink/page",
      method: "GET",
      params: data,
    });
  },
  // 删除关联
  updateSubjectLinkRequst(data) {
    return fetch({
      isLoading: true,
      url: "/subjectLink/update",
      method: "POST",
      data,
    });
  },

  // 专题列表课程分页
  selectPageRequst(data) {
    return fetch({
      isLoading: true,
      url: "/v1/course/selectPage",
      method: "GET",
      params: data,
    });
  },
  // 专题列表咨询分页
  informationSelectPageRequst(data) {
    return fetch({
      isLoading: true,
      url: "/v1/information/selectPage",
      method: "GET",
      params: data,
    });
  },
  // 新增关联
  addSubjectLinkRequst(data) {
    return fetch({
      isLoading: true,
      url: "/subjectLink/save",
      method: "POST",
      data,
    });
  },
};

export default subject;
